import {register} from './../vendor/theme-scripts/theme-sections';
import slideDown from '../util/slide-down';
import hideElement from '../util/hide-element';

const selectors = {
  loginToggle: '#AdminLoginToggle',
  newsletterToggle: '#NewsletterToggle',
  login: '#AdminLogin',
  signup: '#CustomerSignup',
  errors: '.errors',
  contactErrors: '#contact_form .errors',
  loginErrors: '#login_form .errors',
};

class Password {
  constructor(section) {
    this.container = section.container;
    this.loginToggle = this.container.querySelector(selectors.loginToggle);
    this.newsletterToggle = this.container.querySelector(selectors.newsletterToggle);
    this.login = this.container.querySelector(selectors.login);
    this.signup = this.container.querySelector(selectors.signup);
    this.errors = this.container.querySelector(selectors.errors);
    this.contactErrors = this.container.querySelector(selectors.contactErrors);
    this.loginErrors = this.container.querySelector(selectors.loginErrors);
    this.init();
  }

  init() {
    const login = this.login;
    const signup = this.signup;
    const errors = this.errors;
    const contactErrors = this.contactErrors;
    const loginErrors = this.loginErrors;

    this.loginToggle.addEventListener('click', function (e) {
      e.preventDefault();
      slideDown(login);
      hideElement(signup);
      if (errors) {
        hideElement(errors);
      }
    });

    this.newsletterToggle.addEventListener('click', function (e) {
      e.preventDefault();
      hideElement(login);
      slideDown(signup);
      if (errors) {
        hideElement(errors);
      }
    });

    if (contactErrors) {
      hideElement(login);
      slideDown(signup);
    }

    if (loginErrors) {
      slideDown(login);
      hideElement(signup);
    }
  }
}

const passwordSection = {
  onLoad() {
    new Password(this);
  },
};

register('password-template', passwordSection);
